import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-logout\"><defs><style type=\"text/css\"></style></defs><path d=\"M733.866667 469.333333l-46.933334-46.933333 59.733334-59.733333L896 512l-149.333333 149.333333-59.733334-64 42.666667-42.666666H512v-85.333334h221.866667zM725.333333 341.333333h-85.333333V256H341.333333v512h298.666667v-85.333333h85.333333v170.666666H256V170.666667h469.333333v170.666666z\" fill=\"#ffffff\" p-id=\"10687\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logout.svg
// module id = KvOj
// module chunks = 2